import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { CountryDto, StateDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-state-view',
  templateUrl: './state-view.component.html',
  styleUrls: ['./state-view.component.css'],
})
export class StateViewComponent implements OnInit {
  @Input() states: StateDto[];
  @Input() countries: CountryDto[];
  stateForm: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<StateDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();

  SubscriberId = '5ca0c7a7ef1d2e5760762ebd';
  selectedCountry: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedState: any;
  filteredState: Array<any> = [];
  status: boolean;
  selectedStateId: any;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.stateForm = this.fb.group({ States: this.fb.array([]) });
    // this.setState();
  }

  clickme(value) {
    console.log('click ', value);
  }

  // method to display countries
  setState() {
    const control = this.stateForm.controls.States as FormArray;
    this.filteredState.forEach((e) => {
      control.push(
        this.fb.group({
          StateName: e.StateName,
          StateCode: e.StateCode,
          CountryId: e.CountryId,
          id: e.id,
        })
      );
    });
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.stateForm.controls.States as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter state
  selectCountry(event: string) {
    this.filteredState = this.states.filter((s) => s.CountryId === event);
    this.selectedStateId = event;
    const control = this.stateForm.controls.States as FormArray;

    if (this.filteredState.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setState();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  // method to add Country
  addState() {
    console.log('state');
    const control = this.stateForm.controls.States as FormArray;
    control.insert(
      0,
      this.fb.group({
        StateName: ['', Validators.required],
        StateCode: ['', Validators.required],
        CountryId: this.selectedStateId,
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list
  deleteState(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.stateForm.controls.States as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.states.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.states[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'state';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('state');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
